import { searchOrganisations } from '../infrastructure/adapters/organisationService';
import { useSearch } from '@/shared/composables/useSearch';
export function useOrganisations(tableQuery, filtersReady, ast, refinement) {
    const { items: organisations, pageResponse, loading, loadError, loadErrorCode, reload } = useSearch(searchOrganisations, tableQuery, 'organisations', { waitFor: filtersReady, ast, refinement });
    return { organisations, pageResponse, loading, loadError, loadErrorCode, reload };
}
